import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Wrapper from '@templates/dashboard/Wrapper';
import { tConsume } from 'TRANSLATION';
import axios from 'axios';
import api from 'API';
import { Route, Switch, useHistory, useLocation, withRouter } from 'react-router-dom';
import Loadable from 'react-loadable';
import Spinner from '@atoms/spinner';
import { connect, useDispatch, useSelector } from 'react-redux';
import store from 'STORE';
import {
  setPreRegistrationId,
  switchActiveBusinessProfile,
  setUserEmail,
  setCustomersIds,
  setUserDoubleAccountMagmaMonesto,
  setRubTransferEnabled,
} from '@features/personalSlice';
import PageNotFound from '@templates/page-not-found';
import { clearUserToken } from '@features/userTokenSlice';

const AsyncRegistrationCompany = Loadable({
  loader: () => import('../auth/registration-company'),
  loading: Spinner,
  delay: 60,
});

const AsyncRegistrationIndividual = Loadable({
  loader: () => import('../auth/registration-individual'),
  loading: Spinner,
  delay: 60,
});

// const DashboardPage = ({ route, userType, verified }) => {
const DashboardPage = ({ route, userType }) => {
  // const [status, setStatus] = useState(null);
  const acl = useSelector((state) => state.acl.data.acl);
  const dispatch = useDispatch();
  const preRegistrationId = useSelector((state) => state.personal.preRegistrationId);
  const location = useLocation();
  const prevPathname = useRef(null);
  const [userStatus, setUserStatus] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const fetchUserStatus = async () => {
      try {
        const userStatusResponse = await axios(api.users.registration.user_status().AXIOS('get'));

        if (userStatusResponse?.data?.is_rub_transfers_enabled) {
          store.dispatch(setRubTransferEnabled(userStatusResponse.data.is_rub_transfers_enabled));
        }

        if (userStatusResponse?.data?.double_account_magma_monesto) {
          store.dispatch(setUserDoubleAccountMagmaMonesto(userStatusResponse.data.double_account_magma_monesto));
        }

        if (userStatusResponse?.data?.email) {
          store.dispatch(setUserEmail(userStatusResponse.data.email));
        }

        if (userStatusResponse?.data?.customers_ids) {
          store.dispatch(setCustomersIds(userStatusResponse.data.customers_ids));
        }

        setUserStatus(userStatusResponse.data.status);
        if (userStatusResponse.data.status === 'pre_registration') {
          store.dispatch(switchActiveBusinessProfile({ id: '', isNew: false }));
          store.dispatch(setPreRegistrationId({ preRegistrationId: false }));
        }
      } catch (e) {
        console.error(e);
      }
    };

    fetchUserStatus();

    const sessionInterval = setInterval(async () => {
      try {
        const response = await axios(api.users.authorization.session().AXIOS('get'));
      } catch (e) {
        console.log(e);
        clearUserToken();
        history.replace('/');
        window.location.reload();
      }
    }, 30 * 1000);

    return () => {
      clearInterval(sessionInterval);
    };
  }, []);

  // const dispatch = useDispatch();

  // const verificationPages = ['aemi'].includes(userType);

  // useEffect(() => {
  // if (verified || verificationPages) {
  // setStatus('done');
  // }

  // const sessionInterval = setInterval(() => {
  //   dispatch(sessionVerify());
  // }, defaults.timer * 1000);
  //
  // dispatch(fetchUnreadMessages());
  // const unreadMessageInterval = setInterval(() => {
  //   dispatch(fetchUnreadMessages());
  // }, defaults.messageTimer * 1000);

  // return () => {
  //   clearInterval(sessionInterval);
  //   clearInterval(unreadMessageInterval);
  // };
  // }, []);

  // company/registration/verification/password

  // useEffect(() => {
  //   console.log(window.location.pathname);
  //
  //   if (prevPathname.current !== location.pathname) {
  //     if (
  //       userType === 'company' &&
  //       preRegistrationId &&
  //       window.location.pathname &&
  //       !window.location.pathname.startsWith(`${route}/verification`)
  //     ) {
  //       store.dispatch(switchActiveBusinessProfile({ id: '', isNew: false }));
  //       store.dispatch(setPreRegistrationId({ preRegistrationId: false }));
  //     }
  //     prevPathname.current = location.pathname;
  //   }
  // }, [location.pathname, preRegistrationId, route, userType]);

  const renderRegistration = () => {
    if (userType === 'company') {
      return (
        <AsyncRegistrationCompany
          key={location.pathname}
          userType={userType}
          route={route}
          sessionUpdate={() => dispatch(sessionUpdate())}
        />
      );
    }

    return (
      <AsyncRegistrationIndividual
        key={location.pathname}
        userType={userType}
        route={route}
        sessionUpdate={() => dispatch(sessionUpdate())}
      />
    );
  };

  if (userStatus === null) {
    return <Spinner />;
  }
  // if ((!verified && status !== 'done' && !verificationPages) || (userType === 'company' && preRegistrationId)) {
  if (userStatus === 'pre_registration') {
    return (
      <>
        {/*<SessionTimeout userType={userType} />*/}

        <Switch>
          <Route path={route} render={renderRegistration} />
          <Route render={() => <PageNotFound logo={false} />} />
        </Switch>
      </>
    );
  }

  if (userStatus === 'active') {
    return (
      <>
        {/*<SessionTimeout userType={userType} />*/}
        <Wrapper userType={userType} route={route} />
      </>
    );
  }

  return (
    <>
      {/*<SessionTimeout userType={userType} />*/}
      <Wrapper userType={userType} route={route} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.userToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearUserToken: (path) => dispatch(clearUserToken(path)),
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     sessionVerify: () => dispatch(sessionVerify()),
//   };
// };

export default tConsume(connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardPage)));

DashboardPage.propTypes = {
  verified: PropTypes.bool.isRequired,
  userType: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  clearUserToken: PropTypes.func.isRequired,
  // sessionVerify: PropTypes.func,
};
